import { render, staticRenderFns } from "./ProductPrivateSessions.vue?vue&type=template&id=44ce352d&scoped=true&"
import script from "./ProductPrivateSessions.vue?vue&type=script&lang=ts&"
export * from "./ProductPrivateSessions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ce352d",
  null
  
)

export default component.exports